export var CHAT_LOCAL_STORAGE_KEY = "arthur-chat-state";
export var LOADER_LOCAL_STORAGE_KEY = "arthur-loader-state";
//# sourceMappingURL=chat-local-storage.js.map